var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-sections" },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Vakken", icon: "magicon-tiles" } },
        [
          _vm.$can("MUTATE_SECTIONS")
            ? _c(
                "ui-button",
                {
                  attrs: {
                    color: "positive",
                    icon: "magicon-plus",
                    route: "section-add",
                  },
                },
                [_vm._v("Vak toevoegen")]
              )
            : _vm._e(),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "ui-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            clickable: "",
            placeholder: _vm.sections && !_vm.sections.items.length,
            total: _vm.$safe("sections.totalCount"),
            visible: _vm.paging.limit,
          },
          on: { page: _vm.switchPage },
        },
        [
          _c(
            "ui-table-header",
            [
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "name" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Naam")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "1", field: "parcelName" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("In perceel")]
              ),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Alias")]),
              _c(
                "ui-th",
                {
                  attrs: { weight: "1", field: "size" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Oppervlakte")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "createdAt" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Datum aangemaakt")]
              ),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.$safe("sections.items"), function (section) {
            return _c("ui-tr", { key: section.id, attrs: { click: "view" } }, [
              _c("td", [_vm._v(_vm._s(section.name))]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.$safe(section, "parcel.parcelLocation.name")) +
                    " " +
                    _vm._s(_vm.$safe(section, "parcel.parcelLocation.number"))
                ),
              ]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm.$safe(section, "parcel.alias")))
                ),
              ]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("number")(section.size)) + " ha"),
              ]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("date")(section.createdAt, "LL"))),
              ]),
              _c(
                "td",
                {
                  staticClass: "actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Bekijken",
                        expression: "'Bekijken'",
                      },
                    ],
                    attrs: {
                      icon: "entypo-eye",
                      action: "view",
                      to: {
                        name: "section-detail",
                        params: { id: section.id },
                      },
                    },
                  }),
                  _vm.$can("MUTATE_SECTIONS")
                    ? _c("ui-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Wijzigen",
                            expression: "'Wijzigen'",
                          },
                        ],
                        attrs: {
                          icon: "magicon-edit",
                          to: {
                            name: "section-edit",
                            params: { id: section.id },
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.$can("MUTATE_SECTIONS")
                    ? _c("ui-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Verwijderen",
                            expression: "'Verwijderen'",
                          },
                        ],
                        attrs: { icon: "magicon-trash" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteSection(section.id)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }